import LoadUsuario from "../services/LoadUsuario";
import UserService from "../services/UserService";
import RoleService from "../services/RoleService";
import MenuService from "../services/MenuService";
import CompanyService from "../services/CompanyService";
import CatalogService from "../services/CatalogService";
import SaleService from "../services/SaleService";
import ParameterService from "../services/ParameterService";
import ProviderService from "../services/ProviderService";
import VaccineService from "../services/VaccineService";
import DeviceService from "../services/DeviceService";
import ProcedureService from "../services/ProcedureService";
import TypeService from "../services/TypeService";
import ElementService from "../services/ElementService";
import GeofenceService from "../services/GeofenceService";
import AlarmConfigurationService from "../services/AlarmConfigurationService";
import VueJwtDecode from 'vue-jwt-decode'
import router from '../router'
import GoogleService from "../services/GoogleService";
import { Capacitor } from '@capacitor/core';

export default {
  //Método asincrono que realiza el login del usuario
  loadUsuario({ dispatch, commit, state },params){
    state.progress = true;

    LoadUsuario.getLoadUsuario(params)
      .then((response)=>{
        state.progress = false
        if( Capacitor.getPlatform() !== 'web' ) {
          localStorage.sessionStorageIdToken = response.data.id_token;
          localStorage.sessionStorageToken = response.data.token;
        }
        sessionStorage.setItem("id_token",response.data.id_token)
        sessionStorage.setItem("token",response.data.token)
        var clientData = VueJwtDecode.decode(response.data.id_token)
        state.idUser = clientData.sub
        state.roles = clientData.auth.split(",");
        state.authenticated=true
        state.errorLogin = false
        if (state.authenticated) {
          router.push('/device');
        //    const params = new URLSearchParams();
        //    params.append('email', 'admin');
        //    params.append('password', 'admin');
            // return axios.create({
            //     baseURL: 'http://54.87.112.249:8082/api/',
            //     withCredentials: true,
            //     headers: {
            //         'Content-Type': 'application/x-www-form-urlencoded',
            //         'Accept': 'application/json',
            //         "Access-Control-Allow-Origin": "*",
            //         "set-cookie":""
            //     },
            //
            // }).post("session",params).then((response1)=>{
            //     console.log("dentorrr")
            //     console.log(response1)
            //
            //     var socket = new WebSocket('ws://54.87.112.249:8082/api/socket', [], {
            //             'headers': { 'Cookie': response1.headers['set-cookie'][0] }
            //         });
            //
            //         socket.on('open', function open() {
            //             console.log('Succesfully connected to Traccar');
            //         });
            //
            //         socket.on('message', function(message, flags){
            //
            //             var data = JSON.parse(message);
            //             console.log(data)
            //             // Work your magic here
            //             // data.positions contains tracker positions
            //         });
            //
            //         socket.on('disconnect', function(){
            //             console.log('disconnected');
            //         });
            // })
            //     .catch((error)=>{
            //         dispatch("createDialogError",error)
            //     })
        }
      })
      .catch((error)=>{
        state.progress = false
        if(error.response==null){
          state.dialogErrorMessage = "Error en el aplicativo por favor intente más tarde"
          state.dialogError = true
          router.push('/login');
        }else{
          if (error.response && error.response.data && error.response.data.detail && error.response.data.detail.includes('was not activated')) {
            dispatch("createDialogError", error);
            state.errorLogin = true
          }else{
            state.errorLogin = true
            router.push('/login');
          }
        }
      })
  },
  changePassword({ dispatch, commit, state },params){
    state.progress = true
  return new Promise((resolve, reject) => {
    LoadUsuario.changePassword(params)
      .then((response)=>{
        state.progress = false
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
  })
  },
  changePasswordNotSession({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      LoadUsuario.changePasswordNotSession(params)
        .then((response)=>{
          state.progress = false
        })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
  })
  },
  requestPasswordReset({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(LoadUsuario.requestPasswordReset(params)
        .then((response)=>{
          state.progress = false
          router.push('/login');
          state.dialogErrorHeader= "Éxito en recuperación de contraseña"
          state.dialogError= true
          state.dialogErrorMessage= "Se ha enviado un correo electrónico para el cambio de contraseña"
        }))
          .catch((error)=>{
            dispatch("createDialogError",error)
          })
    })
  },

  //Método asincrono que obtiene las compañias
  getCompanies(context){
    context.state.progress = true
    return new Promise((resolve, reject) => {
    context.state.companies=[]
    CompanyService.getCompanies()
      .then((response)=>{
        context.state.progress = false
        for (var i=0;i<response.data.length;i++) {
          context.state.companies.push({
            id: response.data[i].id,
            code: response.data[i].code,
            name: response.data[i].name,
            status: response.data[i].status
          });
        }
      })
        .catch((error)=>{
            context.dispatch("createDialogError",error)
        })
  })
  },
  //Método asincrono que añade las compañias
  addCompany({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
    CompanyService.addCompany(params)
      .then((response)=>{
        state.progress = false
        dispatch("getCompanies")
        router.push('/company');
      })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
  })
  },
  //Método asincrono que edita las compañias
  updateCompany({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
    CompanyService.updateCompany(params)
      .then((response)=>{
        state.progress = false
        dispatch("getCompanies")
        router.push('/company');
      })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
  })
  },
  //Método asincrono que elimina las compañias
  deleteCompany({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
    CompanyService.deleteCompany(params)
      .then((response)=>{
        state.progress = false
        dispatch("getCompanies")
        router.push('/company');
      })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
  })
  },
  //Método asincrono que obtiene las compañias
  getRoles(context){
    context.state.progress = true
    return new Promise((resolve, reject) => {
      context.state.rolesList=[]
      RoleService.getRoles()
        .then((response)=>{
          context.state.progress = false
          for (var i=0;i<response.data.length;i++) {
            context.state.rolesList.push({
              name: response.data[i].name,
              description: response.data[i].description,
              status: response.data[i].status
            });
          }
        })
        .catch((error)=>{
            context.dispatch("createDialogError",error)
        })
  })
  },
  //Método asincrono que añade las compañias
  addRole({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      RoleService.addRole(params)
        .then((response)=>{
          state.progress = false
          dispatch("getRoles")
          router.push('/role');
        })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
  })
  },
  //Método asincrono que edita las compañias
  updateRole({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      RoleService.updateRole(params)
        .then((response)=>{
          state.progress = false
          dispatch("getRoles")
          router.push('/role');
        })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
  })
  },
  //Método asincrono que elimina las compañias
  deleteRole({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      RoleService.deleteRole(params)
        .then((response)=>{
          state.progress = false
          dispatch("getRoles")
          router.push('/role');
        })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
  })
  },
 //Método asincrono que obtiene los parámetros
  getParameters(context){
    context.state.progress = true
    return new Promise((resolve, reject) => {
    context.state.parameters=[]
    ParameterService.getParameters()
      .then((response)=>{
        context.state.progress = false
        for (var i=0;i<response.data.length;i++) {
          context.state.parameters.push({
            id: response.data[i].id,
            value: response.data[i].value,
            name: response.data[i].name,
            enabled: response.data[i].enabled,
            flowTypeId: response.data[i].flowTypeId
          });
        }
      })
        .catch((error)=>{
            context.dispatch("createDialogError",error)
        })
  })
  },
  //Método asincrono que añade los parámetros
  addParameter({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
    ParameterService.addParameter(params)
      .then((response)=>{
        state.progress = false
        dispatch("getParameters")
        router.push('/parameter');
      })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
  })
  },
  //Método asincrono que edita los parámetros
  updateParameter({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
    ParameterService.updateParameter(params)
      .then((response)=>{
        state.progress = false
        dispatch("getParameters")
        router.push('/parameter');
      })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
  })
  },
  //Método asincrono que elimina los parámetros
  deleteParameter({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
    ParameterService.deleteParameter(params)
      .then((response)=>{
        state.progress = false
        dispatch("getParameters")
        router.push('/parameter');
      })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
  })
  },
  //Método asincrono que obtiene los catálogos
  getCatalogs(context){
    context.state.progress = true
    return new Promise((resolve, reject) => {
    context.state.catalogs=[]
    CatalogService.getCatalogs()
      .then((response)=>{
        context.state.progress = false
        for (var i=0;i<response.data.length;i++) {
          context.state.catalogs.push({
            id: response.data[i].id,
            code: response.data[i].code,
            name: response.data[i].name,
            enabled: response.data[i].enabled,
            catalogueItemId: response.data[i].catalogueItemId,
            type: response.data[i].type
          });
        }
      })
        .catch((error)=>{
            context.dispatch("createDialogError",error)
        })
  })
  },
  //Método asincrono que añade los catálogos
  addCatalog({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
    CatalogService.addCatalog(params)
      .then((response)=>{
        state.progress = false
        dispatch("getCatalogs")
        router.push('/catalog');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
  })
  },
  //Método asincrono que edita los catálogos
  updateCatalog({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
    CatalogService.updateCatalog(params)
      .then((response)=>{
        state.progress = false
        dispatch("getCatalogs")
        router.push('/catalog');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
  })
  },
  //Método asincrono que elimina los catálogos
  deleteCatalog({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
    CatalogService.deleteCatalog(params)
      .then((response)=>{
        state.progress = false
        dispatch("getCatalogs")
        router.push('/catalog');
      })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
  })
  },
  //Método asíncrono que obtiene los usuarios asociados a un listado roles
  getUsersByRoleNames(context, params) {
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.usersByRol = []
      RoleService.getUsersByRoleNames(params)
        .then((response) => {
          context.state.progress = false;
          for (var i = 0; i < response.data.length; i++) {
            context.state.usersByRol.push({
              id: response.data[i].id,
              login: response.data[i].login,
              firstName: response.data[i].firstName,
              lastName: response.data[i].lastName,
              email: response.data[i].email,
              identification: response.data[i].identification,
              degree: response.data[i].degree,
              specialty: response.data[i].specialty,
              position: response.data[i].position,
              activated: response.data[i].activated,
              authorities: response.data[i].authorities,
              cellphone: response.data[i].cellphone,
              birthday: response.data[i].birthday,
              document: response.data[i].document,
              documentType: response.data[i].documentType,
              city: response.data[i].city
            });
          }
        })
        .catch((error)=>{
            context.dispatch("createDialogError",error)
        })
  })
  },

  //Método asincrono que obtiene las usuarios
  getUsers(context){
    context.state.progress = true
    return new Promise((resolve, reject) => {
      context.state.users=[]
      resolve(UserService.getUsers()
        .then((response)=>{
          context.state.progress = false
          for (var i=0;i<response.data.length;i++) {
            context.state.users.push(response.data[i]);
          }
        }))
        .catch((error)=>{
          context.dispatch("createDialogError",error)
          reject(error);
        })
    })
  },

  
    //Método asincrono que obtiene las usuarios
    getUsersClient({ dispatch, commit, state }){
      state.progress = true
      return new Promise((resolve, reject) => {
          state.users=[]
          resolve(UserService.getUsersClients()
              .then((response)=>{
                  state.progress = false
                 return response
              })
              .catch((error)=>{
                  dispatch("createDialogError",error)
                  reject(error);
              }))
      })
  },

      //Método asincrono que obtiene las usuarios
      getUsersClientsData({ dispatch, commit, state }){
        state.progress = true
        return new Promise((resolve, reject) => {
            state.users=[]
            resolve(UserService.getUsersClientsData()
                .then((response)=>{
                    state.progress = false
                   return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                    reject(error);
                }))
        })
    },

    
      //Método asincrono que obtiene las usuarios
      getUsersForAdmin({ dispatch, commit, state }){
        state.progress = true
        return new Promise((resolve, reject) => {
            state.users=[]
            resolve(UserService.getUserForAdmin()
                .then((response)=>{
                    state.progress = false
                   return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                    reject(error);
                }))
        })
    },


    //Método asincrono que obtiene las usuarios
    getOneUser({ dispatch, commit, state },params){
        state.progress = true
        return new Promise((resolve, reject) => {
            state.users=[]
            resolve(UserService.getUser(params)
                .then((response)=>{
                    state.progress = false
                   return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                    reject(error);
                }))
        })
    },
  //Método asincrono que obtiene las usuarios
  getClients(context){
    context.state.progress = true
    return new Promise((resolve, reject) => {
      resolve(UserService.getUsers()
          .then((response)=>{
            context.state.progress = false
            return response
          }))
          .catch((error)=>{
            context.dispatch("createDialogError",error)
            reject(error);
          })
    })
  },

  //Método asincrono que añade las usuarios
  addUser({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(UserService.addUser(params)
        .then((response)=>{
          state.progress = false
          dispatch("getUsers")
        }))
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
    })
  },
  //Método asincrono que edita las usuarios
  updateUser({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(UserService.updateUser(params)
        .then((response)=>{
          state.progress = false
          dispatch("getUsers")
        }))
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
    })
  },
  //Método asincrono que elimina las usuarios
  deleteUser({ dispatch, commit, state  },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(UserService.deleteUser(params)
        .then((response)=>{
          state.progress = false
          dispatch("getClients")
        }))
    }, error => {
      dispatch("createDialogError",error)
      reject(error);
    })
  },
  getRols(context){
    context.state.progress = true
    return new Promise((resolve, reject) => {
      context.state.allRols=[]
      UserService.getRols()
        .then((response)=>{
          context.state.progress = false
          for (var i=0;i<response.data.length;i++) {
            context.state.allRols.push(response.data[i]);
          }
        })
          .catch((error) => {
              context.dispatch("createDialogError", error)
          })
    })
  },

  //Método asincrono que obtiene las los clientes para el flow
  getUsersReport(context){
    context.state.progress = true
    return new Promise((resolve, reject) => {
      context.state.usersReport=[]
      UserService.getUsersReport()
        .then((response)=>{
          context.state.progress = false
          context.state.usersReport=response.data
        })
          .catch((error) => {
              context.dispatch("createDialogError", error)
          })
  })
  },

  getMenus(context){
    context.state.progress = true
    return new Promise((resolve, reject) => {
    context.state.menus=[]
    MenuService.getMenus()
      .then((response)=>{
        context.state.progress = false
        for (var i=0;i<response.data.length;i++) {
          context.state.menus.push({
            id: response.data[i].id,
            icon: response.data[i].icon,
            title: response.data[i].title,
            route: response.data[i].route,
            description: response.data[i].description
          });
        }
      })
        .catch((error) => {
            context.dispatch("createDialogError", error)
        })
  })
  },
  //Método asincrono que añade las compañias
  addMenu({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      MenuService.addMenu(params)
      .then((response)=>{
        state.progress = false
        dispatch("getMenus")
        router.push('/menu');
      })
          .catch((error) => {
            dispatch("createDialogError", error)
          })
    })
  },
  //Método asincrono que edita las compañias
  updateMenu({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      MenuService.updateMenu(params)
      .then((response)=>{
        state.progress = false
        dispatch("getMenus")
        router.push('/menu');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
          .catch((error) => {
            dispatch("createDialogError", error)
          })
  })
  },
  //Método asincrono que elimi
  deleteMenu({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      MenuService.deleteMenu(params)
      .then((response)=>{
        state.progress = false
        dispatch("getMenus")
        router.push('/menu');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
          .catch((error) => {
            dispatch("createDialogError", error)
          })
  })
  },
  //Método asincrono que obtiene providers
  getProviders(context){
    context.state.progress = true
    return new Promise((resolve, reject) => {
      context.state.providers=[]
      resolve(ProviderService.getProviders()
          .then((response)=>{
            context.state.progress = false
            for (let i=0;i<response.data.length;i++) {
              context.state.providers.push(response.data[i]);
            }
          })
          .catch((error) => {
              context.dispatch("createDialogError", error)
          }))
    })
  },
  //Método asincrono que añade los proveedores
  addProvider({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(ProviderService.addProvider(params)
          .then((response)=>{
            state.progress = false
            dispatch("getProviders")
            router.push('/provider');
          })
          .catch((error) => {
            dispatch("createDialogError", error)
          }))
    })
  },
  //Método asincrono que edita los proveedores
  updateProvider({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(ProviderService.updateProvider(params)
          .then((response)=>{
            state.progress = false
            dispatch("getProviders")
            router.push('/provider');
          })
          .catch((error) => {
            dispatch("createDialogError", error)
          }))
    })
  },
  //Método asincrono que elimina los proveedores
  deleteProvider({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(ProviderService.deleteProvider(params)
          .then((response)=>{
            state.progress = false
            dispatch("getProviders")
            router.push('/provider');
          })
          .catch((error) => {
            dispatch("createDialogError", error)
          }))
    })
  },

    //Método asincrono que obtiene los examenes de laboratorio
    getDevice(context,params){
        context.state.progress = true
        return new Promise((resolve, reject) => {
            resolve (DeviceService.getDevice(params)
                .then((response)=>{
                    context.state.progress = false
                    return response
                })
                .catch((error) => {
                    context.dispatch("createDialogError", error)
                }))
        })
    },
  //Método asincrono que obtiene los examenes de laboratorio
  getDevices(context){
    context.state.progress = true
    return new Promise((resolve, reject) => {
    resolve (DeviceService.getDevices()
      .then((response)=>{
        context.state.progress = false
        return response
      })
        .catch((error) => {
            context.dispatch("createDialogError", error)
        }))
    })
  },

  //Método asincrono que obtiene los examenes de laboratorio
  getDevicesLocation(context, params){
    // context.state.progress = true
    return new Promise((resolve, reject) => {
      resolve (DeviceService.getDevicesLocation(params)
          .then((response)=>{
            // context.state.progress = false
            return response
          })
          .catch((error) => {
              context.dispatch("createDialogError", error)
          }))
    })
  },

    //Método asincrono que obtiene los examenes de laboratorio
    getDevicesLocationTraccar(context, params){
        // context.state.progress = true
        return new Promise((resolve, reject) => {
            resolve (DeviceService.getDevicesLocationTraccar(params)
                .then((response)=>{
                  if(response.data[0]){
                    let device = response.data[0];
                    let status = "move"; 

                    if (device.attributes && device.attributes.status !== undefined) {
                        switch (device.attributes.status) {
                            case 4:
                            case 68:
                                status = "stop";
                                break;
                            case 70:
                                status = "rely";
                                break;
                        }
                    }
                    let dataResp={data: {
                      result: [
                          {
                              lat: response.data[0].latitude,
                              lng: response.data[0].longitude,
                              direction: response.data[0].course,
                              accStatus: response.data[0].attributes.ignition ? '1' : '0',
                              odometer: response.data[0].attributes.totalDistance ? Number(response.data[0].attributes.totalDistance)/1000 : '',
                              speed: response.data[0].speed,
                              deviceTime: response.data[0].serverTime,
                              attributes: response.data[0].attributes,
                              status: status,
                              motion: response.data[0].attributes.motion ? '1' : '0',
                          }
                      ]
                    }
                  }
                  // context.state.progress = false
                  return dataResp
                  }
                
                }))
        })
    },

  //Método asincrono que obtiene los examenes de laboratorio
  getDevicesLocationTraccarLastRely(context, params) {
    // context.state.progress = true
    return new Promise((resolve, reject) => {
      resolve(DeviceService.getDevicesLocationTraccarLastRely(params)
        .then((response) => {
          if (response.data) {
            let device = response.data;
            let status = "move";

            if (device.attributes && device.attributes.status !== undefined) {
              switch (device.attributes.status) {
                case 4:
                case 68:
                  status = "stop";
                  break;
                case 70:
                  status = "rely";
                  break;
              }
            }
            let dataResp = {
              data: {
                result: [
                  {
                    lat: device.latitude,
                    lng: device.longitude,
                    direction: device.course,
                    accStatus: device.attributes.ignition ? '1' : '0',
                    odometer: device.attributes.totalDistance ? Number(device.attributes.totalDistance)/1000 : '',
                    speed: device.speed,
                    deviceTime: device.serverTime,
                    attributes: device.attributes,
                    status: status,
                    motion: device.attributes.motion ? '1' : '0',
                  }
                ]
              }
            }
            // context.state.progress = false
            return dataResp
          }

        }))
    })
  },
    

    //Método asincrono que obtiene los examenes de laboratorio
    getDevicesLocationTraccarReport(context, params){
        // context.state.progress = true
        return new Promise((resolve, reject) => {
            resolve (DeviceService.getDevicesLocationTraccarReport(params)
                .then((response)=>{
                    let list = []
                    for(const position of response.data){
                       let a = {
                            lat: position.latitude,
                            lng: position.longitude,
                            direction: position.course,
                            accStatus: position.attributes.ignition ? '1' : '0',
                            speed: position.speed,
                            gpsTime: position.serverTime ? position.serverTime : '',
                            attributes: position.attributes
                        }
                        list.push(a)
                    }
                    let dataResp={data: {
                            result: list
                        }
                    }
                    // context.state.progress = false
                    return dataResp
                })
                .catch((error) => {
                    console.log(error)
                }))
        })
    },

    getDevicesLocationStopsTraccarReport(context, params){
        // context.state.progress = true
        return new Promise((resolve, reject) => {
            resolve (DeviceService.getDevicesLocationStopsTraccarReport(params)
                .then((response)=>{
                    return response
                })
                .catch((error) => {
                    console.log(error)
                }))
        })
    },

    //Método asincrono que obtiene los examenes de laboratorio
    getDevicesLocationTraccarAlarm(context, params){
        // context.state.progress = true
        return new Promise((resolve, reject) => {
            resolve (DeviceService.getDevicesLocationTraccarAlarm(params)
                .then((response)=>{
                    return response
                })
                .catch((error) => {
                    console.log(error)
                }))
        })
    },

  //Método asincrono que obtiene los examenes de laboratorio
  sendDeviceAction(context, params){
    context.state.progress = true
    return new Promise((resolve, reject) => {
      resolve (DeviceService.sendDeviceAction(params)
          .then((response)=>{
            context.state.progress = false
            return response
          })
          .catch((error) => {
              context.dispatch("createDialogError", error)
          }))
    })
  },

    //Método asincrono que obtiene los examenes de laboratorio
    sendDeviceActionTraccar(context, params){
        context.state.progress = true
        return new Promise((resolve, reject) => {
            resolve (DeviceService.sendDeviceActionTraccar(params)
                .then((response)=>{
                    context.state.progress = false
                    return response
                })
                .catch((error) => {
                    context.dispatch("createDialogError", error)
                }))
        })
    },

    updateAccumulatorsTraccar(context, params){
          context.state.progress = true
          return new Promise((resolve, reject) => {
              resolve (DeviceService.updateAccumulatorsTraccar(params)
                  .then((response)=>{
                      context.state.progress = false
                      return response
                  })
                  .catch((error) => {
                      context.dispatch("createDialogError", error)
                  }))
          })
      },


  //Método asincrono que obtiene los examenes de laboratorio
  getDevicesByUserLogin(context, params){
    context.state.progress = true
    return new Promise((resolve, reject) => {
      resolve (DeviceService.getDevicesByUserLogin(params)
          .then((response)=>{
            context.state.progress = false
            return response
          })
          .catch((error) => {
              context.dispatch("createDialogError", error)
          }))
    })
  },

  
  //Método asincrono que obtiene los examenes de laboratorio
  getRelatedDevicesByUserLogin(context, params){
    context.state.progress = true
    return new Promise((resolve, reject) => {
      resolve (DeviceService.getRelatedDevicesByUserLogin(params)
          .then((response)=>{
            context.state.progress = false
            return response
          })
          .catch((error) => {
              context.dispatch("createDialogError", error)
          }))
    })
  },

  //Igual que getRelatedDevicesByUserLogin pero usa el endpoint -full,
  //que ademas incluye los equipos embebidos en client_data.devices del usuario y su jerarquia.
  getRelatedDevicesByUserLoginFull(context, params){
    context.state.progress = true
    return new Promise((resolve, reject) => {
      resolve (DeviceService.getRelatedDevicesByUserLoginFull(params)
          .then((response)=>{
            context.state.progress = false
            return response
          })
          .catch((error) => {
              context.dispatch("createDialogError", error)
          }))
    })
  },

    //Método asincrono que obtiene los examenes de laboratorio
    getDevicesByUserLoginNotLoad(context, params){
        return new Promise((resolve, reject) => {
            resolve (DeviceService.getDevicesByUserLogin(params)
                .then((response)=>{
                    return response
                })
                .catch((error) => {
                    context.dispatch("createDialogError", error)
                }))
        })
    },
        //Método asincrono que obtiene los examenes de laboratorio
        getDevicesByUserLoginNotLoadNoError(context, params){
          return new Promise((resolve, reject) => {
              resolve (DeviceService.getDevicesByUserLogin(params)
                  .then((response)=>{
                      return response
                  })
                  .catch((error) => {
                      return error
                  }))
          })
      },
  //Método asincrono que añade las compañias
  addDevice({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(DeviceService.addDevice(params)
          .then((response) => {
            state.progress = false
            return response
          })
          .catch((error) => {
            dispatch("createDialogError", error)
          }))
    })
  },
    //Método asincrono que añade las compañias
    addDeviceTraccar({ dispatch, commit, state },params){
        state.progress = true
        return new Promise((resolve, reject) => {
            resolve(DeviceService.addDeviceTraccar(params)
                .then((response) => {
                    state.progress = false
                    return response
                })
                .catch((error) => {
                    dispatch("createDialogError", error)
                }))
        })
    },

    //Método asincrono que añade las compañias
    getDeviceTraccar({ dispatch, commit, state },params){
        state.progress = true
        return new Promise((resolve, reject) => {
            resolve(DeviceService.getDeviceTraccar(params)
                .then((response) => {
                    state.progress = false
                    return response
                })
                .catch((error) => {
                    dispatch("createDialogError", error)
                }))
        })
    },

    //Método asincrono que añade las compañias
    updateDeviceTraccar({ dispatch, commit, state },params){
        state.progress = true
        return new Promise((resolve, reject) => {
            resolve(DeviceService.updateDeviceTraccar(params)
                .then((response) => {
                    state.progress = false
                    return response
                })
                .catch((error) => {
                    dispatch("createDialogError", error)
                }))
        })
    },

    //Método asincrono que añade las compañias
    deleteDeviceTraccar({ dispatch, commit, state },params){
        state.progress = true
        return new Promise((resolve, reject) => {
            resolve(DeviceService.deleteDeviceTraccar(params)
                .then((response) => {
                    state.progress = false
                    return response
                })
                .catch((error) => {
                    dispatch("createDialogError", error)
                }))
        })
    },


    //Método asincrono que edita las compañias
  updateDevice({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve (DeviceService.updateDevice(params)
      .then((response)=>{
        state.progress = false
        return response
      })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que elimina las compañias
  deleteDevice({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve (DeviceService.deleteDevice(params)
      .then((response)=>{
        state.progress = false
        return response
      })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que obtiene providers
  getVaccines(context){
    context.state.progress = true
    return new Promise((resolve, reject) => {
      context.state.vaccines=[]
      resolve(VaccineService.getVaccines()
          .then((response)=>{
            context.state.progress = false
            for (let i=0;i<response.data.length;i++) {
              context.state.vaccines.push(response.data[i]);
            }
          }))
    }, error => {
      context.state.progress = false
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que añade los proveedores
  addVaccine({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(VaccineService.addVaccine(params)
          .then((response)=>{
            state.progress = false
            dispatch("getVaccines")
            router.push('/vaccine');
          }))
    }, error => {
      state.progress = false
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los proveedores
  updateVaccine({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(VaccineService.updateVaccine(params)
          .then((response)=>{
            state.progress = false
            dispatch("getVaccines")
            router.push('/vaccine');
          }))
    }, error => {
      state.progress = false
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los proveedores
  deleteVaccine({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(VaccineService.deleteVaccine(params)
          .then((response)=>{
            state.progress = false
            dispatch("getVaccines")
            router.push('/vaccine');
          }))
    }, error => {
      state.progress = false
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que obtiene providers
  getProcedures(context){
    context.state.progress = true
    return new Promise((resolve, reject) => {
      context.state.procedures=[]
      resolve(ProcedureService.getProcedures()
          .then((response)=>{
            context.state.progress = false
            for (let i=0;i<response.data.length;i++) {
              context.state.procedures.push(response.data[i]);
            }
          }))
    }, error => {
      context.state.progress = false
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que añade los proveedores
  addProcedure({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(ProcedureService.addProcedure(params)
          .then((response)=>{
            state.progress = false
            dispatch("getProcedures")
            router.push('/procedure');
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que edita los proveedores
  updateProcedure({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(ProcedureService.updateProcedure(params)
          .then((response)=>{
            state.progress = false
            dispatch("getProcedures")
            router.push('/procedure');
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que elimina los proveedores
  deleteProcedure({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(ProcedureService.deleteProcedure(params)
          .then((response)=>{
            state.progress = false
            dispatch("getProcedures")
            router.push('/procedure');
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que obtiene tipos
  getTypes(context){
    context.state.progress = true
    return new Promise((resolve, reject) => {
      context.state.types=[]
      resolve(TypeService.getTypes()
          .then((response)=>{
            context.state.progress = false
            for (let i=0;i<response.data.length;i++) {
              context.state.types.push(response.data[i]);
            }
          })
          .catch((error)=>{
              context.dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que añade los tipos
  addType({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(TypeService.addType(params)
          .then((response)=>{
            for(let i=0;i<params.elements.length;i++){
              params.elements[i].type=response.data.id
              dispatch("addElement",params.elements[i])
            }
            state.progress = false
            dispatch("getTypes")
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que edita los tipos
  updateType({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(TypeService.updateType(params)
          .then((response)=>{
            state.progress = false
            dispatch("deleteElementsByType",params.id)
            for(let i=0;i<params.elements.length;i++){
              params.elements[i].type=params.id
              params.elements[i].id=''
              dispatch("addElement",params.elements[i])
            }
            dispatch("getTypes")
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que elimina los tipos
  deleteType({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(TypeService.deleteType(params)
          .then((response)=>{
            state.progress = false
            dispatch("deleteElementsByType",params)
            dispatch("getTypes")
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que obtiene elementos
  getElements(context){
    context.state.progress = true
    return new Promise((resolve, reject) => {
      context.state.elements=[]
      resolve(ElementService.getElements()
          .then((response)=>{
            context.state.progress = false
            for (let i=0;i<response.data.length;i++) {
              context.state.elements.push(response.data[i]);
            }
          })
          .catch((error)=>{
              context.dispatch("createDialogError",error)
          }))
    })
  },

  //Método asincrono que obtiene elementos
  getElementsByType({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      state.elements=[]
      resolve(ElementService.getElementByType(params)
          .then((response)=>{
            state.progress = false
            for (let i=0;i<response.data.length;i++) {
              state.elements.push(response.data[i]);
            }
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que añade los elementos
  addElement({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(ElementService.addElement(params)
          .then((response)=>{
            state.progress = false
            // dispatch("getElements")
            // router.push('/element');
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que edita los elementos
  updateElement({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(ElementService.updateElement(params)
          .then((response)=>{
            state.progress = false
            // dispatch("getElements")
            // router.push('/elements');
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que elimina los elementos
  deleteElementsByType({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(ElementService.deleteElementsByType(params)
          .then((response)=>{
            state.progress = false
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que obtiene los catálogos
  getSales(context){
    context.state.progress = true
    return new Promise((resolve, reject) => {
      context.state.catalogs=[]
      resolve(SaleService.getSales()
          .then((response)=>{
            context.state.progress = false
            return response
          })
          .catch((error)=>{
            context.dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que añade los catálogos
  addSale({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(SaleService.addSale(params)
          .then((response)=>{
            state.progress = false
            return response
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que edita los catálogos
  updateSale({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(SaleService.updateSale(params)
          .then((response)=>{
            state.progress = false
            return response
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que elimina los catálogos
  deleteSale({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve(SaleService.deleteSale(params)
          .then((response)=>{
            state.progress = false
            return response
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que obtiene los examenes de laboratorio
  getGeofencesByDevice(context, params){
    context.state.progress = true
    return new Promise((resolve, reject) => {
      resolve (GeofenceService.getGeofencesByDevice(params)
          .then((response)=>{
            context.state.progress = false
            return response
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que añade las compañias
  addGeofence({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve (GeofenceService.addGeofence(params)
          .then((response)=>{
            state.progress = false
            return response
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },

    //Método asincrono que añade las compañias
    addGeofenceTraccar({ dispatch, commit, state },params){
        state.progress = true
        return new Promise((resolve, reject) => {
            resolve (GeofenceService.addGeofenceTraccar(params)
                .then((response)=>{
                    state.progress = false
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        })
    },

    //Método asincrono que añade las compañias
    updateGeofenceTraccar({ dispatch, commit, state },params){
        state.progress = true
        return new Promise((resolve, reject) => {
            resolve (GeofenceService.updateGeofenceTraccar(params)
                .then((response)=>{
                    state.progress = false
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        })
    },

    //Método asincrono que añade las compañias
    deleteGeofenceTraccar({ dispatch, commit, state },params){
        state.progress = true
        return new Promise((resolve, reject) => {
            resolve (GeofenceService.deleteGeofenceTraccar(params)
                .then((response)=>{
                    state.progress = false
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        })
    },

    //Método asincrono que añade las compañias
    linkGeofenceTraccarToDevice({ dispatch, commit, state },params){
        state.progress = true
        return new Promise((resolve, reject) => {
            resolve (GeofenceService.linkGeofenceTraccarToDevice(params)
                .then((response)=>{
                    state.progress = false
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        })
    },

    //Método asincrono que añade las compañias
    unlinkGeofenceTraccarToDevice({ dispatch, commit, state },params){
        state.progress = true
        return new Promise((resolve, reject) => {
            resolve (GeofenceService.unlinkGeofenceTraccarToDevice(params)
                .then((response)=>{
                    state.progress = false
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        })
    },
  //Método asincrono que edita las compañias
  updateGeofence({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve (GeofenceService.updateGeofence(params)
          .then((response)=>{
            state.progress = false
            return response
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },
  //Método asincrono que elimina las compañias
  deleteGeofence({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve (GeofenceService.deleteGeofence(params)
          .then((response)=>{
            state.progress = false
            return response
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },

  getDeviceReport({ dispatch, commit, state },params){
    state.progress = true
    return new Promise((resolve, reject) => {
      resolve (DeviceService.getDeviceReport(params)
          .then((response)=>{
            state.progress = false
            return response
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    })
  },

    //Método asincrono que obtiene los examenes de laboratorio
    getAlarmConfigurationByRole(context, params){
        context.state.progress = true
        return new Promise((resolve, reject) => {
            resolve (AlarmConfigurationService.getAlarmConfigurationByRole(params)
                .then((response)=>{
                    context.state.progress = false
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        })
    },
    //Método asincrono que obtiene los examenes de laboratorio
    getAlarmConfigurationByUser(context, params){
        context.state.progress = true
        return new Promise((resolve, reject) => {
            resolve (AlarmConfigurationService.getAlarmConfigurationByUser(params)
                .then((response)=>{
                    context.state.progress = false
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        })
    },
    //Método asincrono que edita las compañias
    addAlarmConfiguration({ dispatch, commit, state },params){
        state.progress = true
        return new Promise((resolve, reject) => {
            resolve (AlarmConfigurationService.addAlarmConfiguration(params)
                .then((response)=>{
                    state.progress = false
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        })
    },
    //Método asincrono que edita las compañias
    updateAlarmConfiguration({ dispatch, commit, state },params){
        state.progress = true
        return new Promise((resolve, reject) => {
            resolve (AlarmConfigurationService.updateAlarmConfiguration(params)
                .then((response)=>{
                    state.progress = false
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        })
    },
    //Método asincrono que elimina las compañias
    deleteAlarmConfiguration({ dispatch, commit, state },params){
        state.progress = true
        return new Promise((resolve, reject) => {
            resolve (AlarmConfigurationService.deleteAlarmConfiguration(params)
                .then((response)=>{
                    state.progress = false
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        })
    },

    getAlarmConfiguration({ dispatch, commit, state },params){
        state.progress = true
        return new Promise((resolve, reject) => {
            resolve (AlarmConfigurationService.getAlarmConfiguration(params)
                .then((response)=>{
                    state.progress = false
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        })
    },

    //Método asincrono que obtiene los examenes de laboratorio
    getAllAuthorities(context, params){
        context.state.progress = true
        return new Promise((resolve, reject) => {
            resolve (UserService.getAllRoles(params)
                .then((response)=>{
                    context.state.progress = false
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        })
    },

    //Método asincrono que obtiene los examenes de laboratorio
    getAlarmsByImei(context, params){
        context.state.progress = true
        return new Promise((resolve, reject) => {
            resolve (AlarmConfigurationService.getAlarmByImei(params)
                .then((response)=>{
                    context.state.progress = false
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        })
    },
    //Método asincrono que obtiene los examenes de laboratorio
    getAlarmEventTraccar(context, params){
        context.state.progress = true
        return new Promise((resolve, reject) => {
            resolve (AlarmConfigurationService.getAlarmEventTraccar(params)
                .then((response)=>{
                    context.state.progress = false
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        })
    },

    //Método asincrono que obtiene los examenes de laboratorio
    getStreetFromCoordinates(context, params){
        //context.state.progress = true
        return new Promise((resolve, reject) => {
            resolve (GoogleService.getStreetFromCoordinates(params)
                .then((response)=>{
                    let direction = ""
                   // context.state.progress = false
                    if(response.data.results!=null){
                        for (let i = 0; i < response.data.results[0].address_components.length; i++) {
                            if(response.data.results[0].address_components.length-1==i){
                                direction = direction + response.data.results[0].address_components[i].long_name
                            }else{
                                direction = direction + response.data.results[0].address_components[i].long_name+", "
                            }
                        }
                    }
                    return direction
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        })
    },
  createDialogError({ dispatch, commit, state },error){
    if (error.response.status == 401 && error.response.data != null && error.response.data.detail.includes('was not activated')) {
      state.dialogErrorMessage = "Su usuario se encuentra inactivo. Por favor comunicarse con T.U. GPS al 0998704891"
    } else if (error.response.status == 401 || (error.response.data != null && error.response.data.detail == '401 null')) {
        state.dialogErrorMessage = "Sesión caducada. Por favor ingresar sus credenciales para acceder al sistema"
        sessionStorage.setItem("id_token", null)
        sessionStorage.setItem("token", null)
        localStorage.removeItem("sessionStorageIdToken");
        localStorage.removeItem("sessionStorageToken");
        var url = window.location.href;
        var to = url.lastIndexOf('/') + 1;
        window.location = url.substring(0, to);
        location.reload()
      } else {
      state.dialogErrorMessage = error.response.data.title!=null?error.response.data.title:"Se ha presentado un error en el aplicativo. Vuelva a intentarlo más tarde"
    }
    state.dialogErrorHeader= "Error en la aplicación",
    state.progress = false
    state.dialogError = true

  },

  createDialogErrorWithMessage({ state }, message) {
    state.dialogErrorMessage = message ? message: "Se ha presentado un error en el aplicativo. Vuelva a intentarlo más tarde"
    state.dialogErrorHeader= "Error en la aplicación",
    state.progress = false
    state.dialogError = true
  },
}



// WEBPACK FOOTER //
// ./src/store/actions.js